/* eslint-disable max-lines */
import React from 'react';

export const CustomerCheckIcon = (
  <svg
    fill="none"
    height="66"
    viewBox="0 0 67 66"
    width="67"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_3353_205854)">
      <path
        d="M3 32C3 15.4315 16.4315 2 33 2C49.5685 2 63 15.4315 63 32C63 48.5685 49.5685 62 33 62C16.4315 62 3 48.5685 3 32Z"
        fill="white"
      />
      <path
        d="M33 2.5C49.2924 2.5 62.5 15.7076 62.5 32C62.5 48.2924 49.2924 61.5 33 61.5C16.7076 61.5 3.5 48.2924 3.5 32C3.5 15.7076 16.7076 2.5 33 2.5Z"
        stroke="#8C96A2"
      />
      <path
        d="M25.8261 23.1523L43.3304 35.2045C44.0478 35.7306 44.4782 36.5915 44.3348 37.4523C44.1913 38.2176 43.713 38.8871 42.2304 38.5045C42.2304 38.5045 43.2826 41.8045 40.3652 41.3263C40.3652 41.3263 40.7478 44.1002 38.1652 43.8132C38.1652 43.8132 38.213 46.5871 35.7739 45.8697C33.3348 45.1523 23.6739 37.5958 22.813 36.0654C21.9522 34.535 20.1348 31.3306 20.1348 31.3306L25.8261 23.1523Z"
        fill="white"
      />
      <path
        d="M36.5392 46.2048C36.3001 46.2048 36.0131 46.157 35.7262 46.0613C33.1914 45.2961 23.5305 37.7874 22.6218 36.1613C21.761 34.6309 19.9436 31.4265 19.9436 31.4265C19.8958 31.3309 19.8958 31.2352 19.9436 31.1874L25.6349 23.0091C25.7305 22.9135 25.874 22.8657 25.9697 22.9613L43.474 35.0135C44.2871 35.5874 44.7175 36.5918 44.574 37.5004C44.4784 38.0265 44.2871 38.4091 43.9045 38.6004C43.5697 38.8396 43.0914 38.8874 42.5653 38.7918C42.661 39.3657 42.8045 40.4178 42.2784 41.0396C41.9436 41.47 41.3697 41.6135 40.6523 41.5657C40.6523 42.0439 40.6045 42.9048 40.0305 43.4787C39.6479 43.8613 39.074 44.0526 38.4045 44.0526C38.3566 44.4831 38.2131 45.3918 37.5914 45.87C37.2566 46.0613 36.9218 46.2048 36.5392 46.2048ZM20.4218 31.2831C20.7566 31.9048 22.2871 34.5352 23.0523 35.8744C23.8653 37.4048 33.4784 44.8657 35.8697 45.5831C36.4914 45.7744 36.9697 45.7265 37.3045 45.4874C37.974 45.0091 37.974 43.8135 37.974 43.8135C37.974 43.7657 38.0218 43.67 38.0697 43.6222C38.1175 43.5744 38.2131 43.5744 38.261 43.5744C38.9305 43.6222 39.4088 43.5265 39.7436 43.1918C40.3653 42.57 40.2218 41.3744 40.2218 41.3744C40.2218 41.2787 40.2218 41.2309 40.2697 41.1831C40.3175 41.1352 40.4131 41.0874 40.461 41.1352C41.1784 41.2309 41.6566 41.1352 41.9436 40.8004C42.5175 40.0831 42.0871 38.6483 42.0392 38.6004C41.9914 38.5048 42.0392 38.4091 42.0871 38.3613C42.1349 38.3135 42.2305 38.2657 42.3262 38.3135C42.9479 38.457 43.3784 38.457 43.6653 38.2657C43.9045 38.1222 44.0479 37.8352 44.0958 37.4526C44.2392 36.6874 43.8566 35.9222 43.1871 35.4439L25.874 23.4396L20.4218 31.2831Z"
        fill="#121926"
      />
      <path
        d="M48.8303 31.9998C48.7825 31.9998 48.6869 31.952 48.639 31.9042L38.4043 21.1433C38.3086 21.0476 38.3086 20.9042 38.4043 20.8085L40.8912 17.9868C40.9869 17.8911 41.1303 17.8911 41.226 17.9868C41.3217 18.0824 41.3217 18.2259 41.226 18.3216L38.8825 20.952L48.7825 31.3781L51.413 28.4129C51.5086 28.3172 51.6521 28.3172 51.7477 28.4129C51.8434 28.5085 51.8434 28.652 51.7477 28.7476L48.926 31.9042C48.9738 31.952 48.8782 31.9998 48.8303 31.9998Z"
        fill="#121926"
      />
      <path
        d="M18.3653 34.0084C18.3174 34.0084 18.2696 34.0084 18.2218 33.9606L15.0174 31.8084C14.9218 31.7128 14.874 31.5693 14.9696 31.4736C15.0653 31.378 15.2087 31.3302 15.3044 31.4258L18.3174 33.4345L26.2087 22.0997L23.5783 20.091C23.4348 20.0432 23.4348 19.8997 23.4827 19.8041C23.5783 19.7084 23.7218 19.6606 23.8174 19.7562L26.6392 21.9084C26.7348 22.0041 26.7827 22.1475 26.687 22.2432L18.5566 33.9128C18.5087 33.9606 18.4131 34.0084 18.3653 34.0084Z"
        fill="#121926"
      />
      <path
        d="M40.3178 23.0088L38.9786 24.061L34.2438 23.6305C34.0047 23.6305 33.7656 23.6784 33.5743 23.8697L30.9439 26.4523C30.9439 26.4523 29.7004 31.9523 29.9873 32.2392C30.2743 32.5262 32.0438 32.1436 32.6656 30.9001C33.2873 29.6566 33.6221 28.5088 33.9091 28.7479C34.196 28.987 37.2091 31.0914 38.596 29.4653L37.3525 30.9479L43.4265 35.2523C43.4265 35.2523 44.7178 32.574 44.6221 31.6175C44.5265 30.661 46.3917 29.1784 46.3917 29.1784L40.3178 23.0088Z"
        fill="white"
      />
      <path
        d="M43.4263 35.4916C43.3784 35.4916 43.3306 35.4916 43.2828 35.4437L37.2089 31.1394C37.1611 31.0916 37.1132 31.0437 37.1132 30.9959C37.1132 30.9481 37.1132 30.8524 37.1611 30.8046L37.5915 30.2785C36.0611 30.5177 34.2437 29.2742 33.8132 28.9872C33.7176 29.1307 33.5263 29.5611 33.335 29.8959C33.1915 30.2307 33.048 30.6133 32.8567 30.9959C32.4263 31.9046 31.4219 32.4307 30.6089 32.5264C30.3697 32.5742 29.9871 32.5742 29.7958 32.3829C29.7002 32.2872 29.4132 32.0003 30.7045 26.4046C30.7045 26.3568 30.7524 26.309 30.7524 26.309L33.3828 23.7264C33.6219 23.4872 33.9089 23.3916 34.1958 23.4394L38.835 23.8698L40.0784 22.8655C40.1263 22.8177 40.1263 22.8177 40.1741 22.8177C40.2697 22.7698 40.3654 22.8177 40.4132 22.8655L46.4871 29.0351C46.535 29.0829 46.5828 29.1307 46.535 29.2264C46.535 29.2742 46.4871 29.3698 46.4393 29.4177C45.7697 29.9437 44.7176 31.0437 44.7654 31.6177C44.861 32.622 43.7132 35.109 43.5697 35.3959C43.5219 35.4437 43.4741 35.4916 43.4263 35.5394C43.4741 35.4916 43.4263 35.4916 43.4263 35.4916ZM37.6871 30.9003L43.3306 34.8698C43.7132 34.009 44.4306 32.2872 44.3828 31.6177C44.2871 30.709 45.4828 29.5611 46.0089 29.1307L40.2697 23.2959L39.0741 24.2524C39.0263 24.3003 38.9784 24.3003 38.8828 24.3003L34.148 23.8698C33.9567 23.8698 33.8132 23.9177 33.6697 24.0133L31.0871 26.5481C30.5611 28.9394 30.035 31.522 30.0828 32.0481C30.1784 32.0481 30.4176 32.0481 30.7524 31.9524C31.0393 31.8568 31.948 31.5698 32.3306 30.709C32.5219 30.3264 32.6654 29.9916 32.8089 29.6568C33.1915 28.7959 33.335 28.4611 33.6219 28.4133C33.7176 28.3655 33.8611 28.4133 33.9089 28.509C33.9567 28.5568 36.9697 30.7568 38.2611 29.2742C38.3567 29.1785 38.5002 29.1785 38.5958 29.2742C38.6915 29.3698 38.6915 29.5133 38.6437 29.609L37.6871 30.9003Z"
        fill="#121926"
      />
      <path
        d="M22.4305 36.4479L24.4392 34.4392C25.0132 33.8653 25.9218 33.8653 26.4958 34.4392C27.0697 35.0131 27.0697 35.9218 26.4958 36.4957L24.4871 38.5044C23.961 39.0305 23.1001 39.0305 22.574 38.5044L22.3827 38.3131C21.9045 37.8349 21.9045 36.974 22.4305 36.4479Z"
        fill="white"
      />
      <path
        d="M23.5303 39.1744C23.0999 39.1744 22.7173 39.0309 22.4303 38.6961L22.239 38.5048C21.952 38.2179 21.7607 37.7874 21.7607 37.4048C21.7607 36.9744 21.9042 36.5918 22.239 36.3048L24.2477 34.2961C24.9173 33.6266 25.9694 33.6266 26.639 34.2961C27.3086 34.9657 27.3086 36.0179 26.639 36.6874L24.6303 38.6961C24.3912 38.9831 23.9607 39.1744 23.5303 39.1744ZM25.4434 34.2961C25.1086 34.2961 24.8216 34.3918 24.5825 34.6309L22.5738 36.6396C22.3825 36.8309 22.239 37.1179 22.239 37.4048C22.239 37.6918 22.3347 37.9787 22.5738 38.17L22.7651 38.3613C23.1955 38.7918 23.9129 38.7918 24.3434 38.3613L26.352 36.3526C26.8303 35.8744 26.8303 35.1092 26.352 34.6309C26.1129 34.3918 25.7781 34.2961 25.4434 34.2961Z"
        fill="#121926"
      />
      <path
        d="M24.7739 38.4083L26.8783 36.3039C27.5478 35.6344 28.6478 35.6344 29.3174 36.3039C29.987 36.9735 29.987 38.0735 29.3174 38.7431L27.2131 40.8474C26.5913 41.4691 25.6348 41.4691 25.0131 40.8474L24.7739 40.6083C24.1522 40.0344 24.1522 39.03 24.7739 38.4083Z"
        fill="white"
      />
      <path
        d="M26.1132 41.5651C25.6349 41.5651 25.2045 41.3738 24.8219 41.0391L24.5827 40.7999C24.2479 40.4652 24.0566 39.9869 24.0566 39.5086C24.0566 39.0304 24.2479 38.5521 24.5827 38.2173L26.6871 36.113C27.0697 35.7304 27.5479 35.5391 28.074 35.5391C28.6001 35.5391 29.0784 35.7304 29.461 36.113C29.8436 36.4956 30.0349 36.9738 30.0349 37.4999C30.0349 38.026 29.8436 38.5043 29.461 38.8869L27.3566 40.9912C27.0219 41.4217 26.5914 41.5651 26.1132 41.5651ZM28.1219 36.0651C27.7392 36.0651 27.3566 36.2086 27.0697 36.4956L24.9653 38.5999C24.7262 38.8391 24.5827 39.1738 24.5827 39.5565C24.5827 39.9391 24.7262 40.226 24.9653 40.513L25.2045 40.7521C25.7306 41.2782 26.5436 41.2782 27.0697 40.7521L29.174 38.6478C29.461 38.3608 29.6045 37.9782 29.6045 37.5956C29.6045 37.213 29.461 36.8304 29.174 36.5434C28.8871 36.2565 28.5045 36.0651 28.1219 36.0651Z"
        fill="#121926"
      />
      <path
        d="M27.2131 40.9436L29.5088 38.6479C30.1305 38.0262 31.1349 38.0262 31.7566 38.6479C32.3784 39.2697 32.3784 40.274 31.7566 40.8958L29.461 43.1914C28.8871 43.7653 27.9784 43.7653 27.4523 43.1914L27.2131 42.9523C26.6392 42.4262 26.6392 41.5175 27.2131 40.9436Z"
        fill="white"
      />
      <path
        d="M28.4565 43.8611C28.0261 43.8611 27.5956 43.6698 27.2608 43.3828L27.0217 43.1437C26.6869 42.8089 26.5435 42.4263 26.5435 41.9481C26.5435 41.5176 26.7348 41.0872 27.0217 40.7524L29.3174 38.4568C29.6522 38.122 30.1304 37.9307 30.6087 37.9307C31.0869 37.9307 31.5652 38.122 31.9 38.4568C32.2348 38.7915 32.4261 39.2698 32.4261 39.7481C32.4261 40.2263 32.2348 40.7046 31.9 41.0394L29.6522 43.3828C29.3174 43.6698 28.8869 43.8611 28.4565 43.8611ZM30.6565 38.4089C30.2739 38.4089 29.9391 38.5524 29.7 38.7915L27.4043 41.0872C27.1652 41.3263 27.0695 41.6133 27.0695 41.9481C27.0695 42.2828 27.213 42.5698 27.4043 42.8089L27.6435 43.0481C28.0739 43.4785 28.8869 43.4785 29.3174 43.0481L31.613 40.7524C31.8522 40.5133 31.9956 40.1785 31.9956 39.7959C31.9956 39.4133 31.8522 39.0785 31.613 38.8394C31.3739 38.5524 31.0391 38.4089 30.6565 38.4089Z"
        fill="#121926"
      />
      <path
        d="M29.7001 43.2391L31.9479 40.8956C32.474 40.3217 33.3827 40.3217 33.9566 40.8478L34.1001 40.9912C34.674 41.5173 34.674 42.426 34.1479 42.9999L31.9001 45.3434C31.4218 45.8695 30.6088 45.8695 30.0827 45.3912L29.7479 45.0565C29.2218 44.5782 29.2218 43.7652 29.7001 43.2391Z"
        fill="white"
      />
      <path
        d="M30.9434 45.9655C30.5608 45.9655 30.1782 45.822 29.8912 45.535L29.5564 45.2002C28.9347 44.6263 28.9347 43.6698 29.5086 43.0481L29.6999 42.8568L31.7564 40.6568C32.3782 39.9872 33.4304 39.9872 34.0999 40.6089L34.2434 40.7524C34.5782 41.0394 34.7695 41.4698 34.7695 41.9002C34.7695 42.3307 34.626 42.7611 34.3391 43.0959L32.0434 45.4872C31.8043 45.7741 31.4217 45.9655 30.9434 45.9655C30.9912 45.9655 30.9912 45.9655 30.9434 45.9655ZM29.7956 43.5263C29.5086 43.9568 29.5564 44.5307 29.9391 44.9133L30.2738 45.2481C30.4651 45.4394 30.7521 45.535 30.9912 45.535C31.2782 45.535 31.5173 45.3915 31.7086 45.2002L33.9564 42.8568C34.1478 42.6176 34.2912 42.3307 34.2912 41.9959C34.2912 41.6611 34.1478 41.3741 33.9086 41.1828L33.7651 41.0394C33.2869 40.6089 32.5695 40.6089 32.0912 41.0872L29.7956 43.5263Z"
        fill="#121926"
      />
      <path
        d="M42.2307 38.6954C42.1828 38.6954 42.135 38.6954 42.0872 38.6476L39.5524 37.0693C39.4568 37.0215 39.4089 36.8302 39.4568 36.7345C39.5046 36.6389 39.6959 36.5911 39.7915 36.6389L42.3263 38.2171C42.422 38.265 42.4698 38.4563 42.422 38.5519C42.3741 38.6476 42.3263 38.6954 42.2307 38.6954Z"
        fill="#121926"
      />
      <path
        d="M40.5085 41.5177C40.4607 41.5177 40.4128 41.5177 40.365 41.4698L37.8302 39.8916C37.7346 39.8438 37.6868 39.6525 37.7346 39.5568C37.7824 39.4611 37.9737 39.4133 38.0694 39.4611L40.6041 41.0394C40.6998 41.0872 40.7476 41.2785 40.6998 41.3742C40.652 41.5177 40.6041 41.5177 40.5085 41.5177Z"
        fill="#121926"
      />
      <path
        d="M38.4523 43.9561C38.4045 43.9561 38.3567 43.9561 38.3089 43.9083L35.7741 42.3301C35.6784 42.2822 35.6306 42.0909 35.6784 41.9953C35.7263 41.8996 35.9176 41.8518 36.0132 41.8996L38.548 43.4779C38.6436 43.5257 38.6915 43.717 38.6436 43.8127C38.5958 43.9083 38.548 43.9561 38.4523 43.9561Z"
        fill="#121926"
      />
      <path
        d="M21.9519 19.9955L23.6737 21.2389C24.2954 21.6694 24.4867 22.5781 24.0085 23.1998L18.6998 30.7563C18.2693 31.3781 17.3606 31.5694 16.7389 31.0911L15.0171 29.8476C14.3954 29.4172 14.2041 28.5085 14.6824 27.8868L19.9911 20.3302C20.4215 19.7085 21.2824 19.565 21.9519 19.9955Z"
        fill="#D1E9FF"
      />
      <path
        d="M41.7041 20.33L43.1867 18.8474C43.7607 18.2735 44.6215 18.2735 45.1954 18.8474L51.0781 24.73C51.652 25.3039 51.652 26.1648 51.0781 26.7387L49.5954 28.2213C49.0215 28.7953 48.1607 28.7953 47.5867 28.2213L41.7041 22.3387C41.178 21.7648 41.178 20.8561 41.7041 20.33Z"
        fill="#D1E9FF"
      />
      <rect fill="#1570EF" height="15" rx="7.5" width="15" x="48.5" y="3.5" />
      <rect height="15" rx="7.5" stroke="#1570EF" width="15" x="48.5" y="3.5" />
      <path
        clip-rule="evenodd"
        d="M60.3536 7.64645C60.5488 7.84171 60.5488 8.15829 60.3536 8.35355L54.8536 13.8536C54.6583 14.0488 54.3417 14.0488 54.1464 13.8536L51.6464 11.3536C51.4512 11.1583 51.4512 10.8417 51.6464 10.6464C51.8417 10.4512 52.1583 10.4512 52.3536 10.6464L54.5 12.7929L59.6464 7.64645C59.8417 7.45118 60.1583 7.45118 60.3536 7.64645Z"
        fill="white"
        fill-rule="evenodd"
      />
    </g>
    <defs>
      <filter
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
        height="66"
        id="filter0_dd_3353_205854"
        width="67"
        x="0"
        y="0"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0705882 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 0.06 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow_3353_205854"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0705882 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 0.1 0"
        />
        <feBlend
          in2="effect1_dropShadow_3353_205854"
          mode="normal"
          result="effect2_dropShadow_3353_205854"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_3353_205854"
          mode="normal"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const CustomerIcon = (
  <svg
    fill="none"
    height="66"
    viewBox="0 0 66 66"
    width="66"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_3353_197334)">
      <path
        d="M3 32C3 15.4315 16.4315 2 33 2C49.5685 2 63 15.4315 63 32C63 48.5685 49.5685 62 33 62C16.4315 62 3 48.5685 3 32Z"
        fill="white"
      />
      <path
        d="M33 2.5C49.2924 2.5 62.5 15.7076 62.5 32C62.5 48.2924 49.2924 61.5 33 61.5C16.7076 61.5 3.5 48.2924 3.5 32C3.5 15.7076 16.7076 2.5 33 2.5Z"
        stroke="#8C96A2"
      />
      <path
        d="M25.8261 23.1523L43.3304 35.2045C44.0478 35.7306 44.4782 36.5915 44.3348 37.4523C44.1913 38.2176 43.713 38.8871 42.2304 38.5045C42.2304 38.5045 43.2826 41.8045 40.3652 41.3263C40.3652 41.3263 40.7478 44.1002 38.1652 43.8132C38.1652 43.8132 38.213 46.5871 35.7739 45.8697C33.3348 45.1523 23.6739 37.5958 22.813 36.0654C21.9522 34.535 20.1348 31.3306 20.1348 31.3306L25.8261 23.1523Z"
        fill="white"
      />
      <path
        d="M36.5392 46.2048C36.3001 46.2048 36.0131 46.157 35.7262 46.0613C33.1914 45.2961 23.5305 37.7874 22.6218 36.1613C21.761 34.6309 19.9436 31.4265 19.9436 31.4265C19.8958 31.3309 19.8958 31.2352 19.9436 31.1874L25.6349 23.0091C25.7305 22.9135 25.874 22.8657 25.9697 22.9613L43.474 35.0135C44.2871 35.5874 44.7175 36.5918 44.574 37.5004C44.4784 38.0265 44.2871 38.4091 43.9045 38.6004C43.5697 38.8396 43.0914 38.8874 42.5653 38.7918C42.661 39.3657 42.8045 40.4178 42.2784 41.0396C41.9436 41.47 41.3697 41.6135 40.6523 41.5657C40.6523 42.0439 40.6045 42.9048 40.0305 43.4787C39.6479 43.8613 39.074 44.0526 38.4045 44.0526C38.3566 44.4831 38.2131 45.3918 37.5914 45.87C37.2566 46.0613 36.9218 46.2048 36.5392 46.2048ZM20.4218 31.2831C20.7566 31.9048 22.2871 34.5352 23.0523 35.8744C23.8653 37.4048 33.4784 44.8657 35.8697 45.5831C36.4914 45.7744 36.9697 45.7265 37.3045 45.4874C37.974 45.0091 37.974 43.8135 37.974 43.8135C37.974 43.7657 38.0218 43.67 38.0697 43.6222C38.1175 43.5744 38.2131 43.5744 38.261 43.5744C38.9305 43.6222 39.4088 43.5265 39.7436 43.1918C40.3653 42.57 40.2218 41.3744 40.2218 41.3744C40.2218 41.2787 40.2218 41.2309 40.2697 41.1831C40.3175 41.1352 40.4131 41.0874 40.461 41.1352C41.1784 41.2309 41.6566 41.1352 41.9436 40.8004C42.5175 40.0831 42.0871 38.6483 42.0392 38.6004C41.9914 38.5048 42.0392 38.4091 42.0871 38.3613C42.1349 38.3135 42.2305 38.2657 42.3262 38.3135C42.9479 38.457 43.3784 38.457 43.6653 38.2657C43.9045 38.1222 44.0479 37.8352 44.0958 37.4526C44.2392 36.6874 43.8566 35.9222 43.1871 35.4439L25.874 23.4396L20.4218 31.2831Z"
        fill="#121926"
      />
      <path
        d="M48.8303 31.9998C48.7825 31.9998 48.6869 31.952 48.639 31.9042L38.4043 21.1433C38.3086 21.0476 38.3086 20.9042 38.4043 20.8085L40.8912 17.9868C40.9869 17.8911 41.1303 17.8911 41.226 17.9868C41.3217 18.0824 41.3217 18.2259 41.226 18.3216L38.8825 20.952L48.7825 31.3781L51.413 28.4129C51.5086 28.3172 51.6521 28.3172 51.7477 28.4129C51.8434 28.5085 51.8434 28.652 51.7477 28.7476L48.926 31.9042C48.9738 31.952 48.8782 31.9998 48.8303 31.9998Z"
        fill="#121926"
      />
      <path
        d="M18.3653 34.0084C18.3174 34.0084 18.2696 34.0084 18.2218 33.9606L15.0174 31.8084C14.9218 31.7128 14.874 31.5693 14.9696 31.4736C15.0653 31.378 15.2087 31.3302 15.3044 31.4258L18.3174 33.4345L26.2087 22.0997L23.5783 20.091C23.4348 20.0432 23.4348 19.8997 23.4827 19.8041C23.5783 19.7084 23.7218 19.6606 23.8174 19.7562L26.6392 21.9084C26.7348 22.0041 26.7827 22.1475 26.687 22.2432L18.5566 33.9128C18.5087 33.9606 18.4131 34.0084 18.3653 34.0084Z"
        fill="#121926"
      />
      <path
        d="M40.3178 23.0088L38.9786 24.061L34.2438 23.6305C34.0047 23.6305 33.7656 23.6784 33.5743 23.8697L30.9439 26.4523C30.9439 26.4523 29.7004 31.9523 29.9873 32.2392C30.2743 32.5262 32.0438 32.1436 32.6656 30.9001C33.2873 29.6566 33.6221 28.5088 33.9091 28.7479C34.196 28.987 37.2091 31.0914 38.596 29.4653L37.3525 30.9479L43.4265 35.2523C43.4265 35.2523 44.7178 32.574 44.6221 31.6175C44.5265 30.661 46.3917 29.1784 46.3917 29.1784L40.3178 23.0088Z"
        fill="white"
      />
      <path
        d="M43.4263 35.4916C43.3784 35.4916 43.3306 35.4916 43.2828 35.4437L37.2089 31.1394C37.1611 31.0916 37.1132 31.0437 37.1132 30.9959C37.1132 30.9481 37.1132 30.8524 37.1611 30.8046L37.5915 30.2785C36.0611 30.5177 34.2437 29.2742 33.8132 28.9872C33.7176 29.1307 33.5263 29.5611 33.335 29.8959C33.1915 30.2307 33.048 30.6133 32.8567 30.9959C32.4263 31.9046 31.4219 32.4307 30.6089 32.5264C30.3697 32.5742 29.9871 32.5742 29.7958 32.3829C29.7002 32.2872 29.4132 32.0003 30.7045 26.4046C30.7045 26.3568 30.7524 26.309 30.7524 26.309L33.3828 23.7264C33.6219 23.4872 33.9089 23.3916 34.1958 23.4394L38.835 23.8698L40.0784 22.8655C40.1263 22.8177 40.1263 22.8177 40.1741 22.8177C40.2697 22.7698 40.3654 22.8177 40.4132 22.8655L46.4871 29.0351C46.535 29.0829 46.5828 29.1307 46.535 29.2264C46.535 29.2742 46.4871 29.3698 46.4393 29.4177C45.7697 29.9437 44.7176 31.0437 44.7654 31.6177C44.861 32.622 43.7132 35.109 43.5697 35.3959C43.5219 35.4437 43.4741 35.4916 43.4263 35.5394C43.4741 35.4916 43.4263 35.4916 43.4263 35.4916ZM37.6871 30.9003L43.3306 34.8698C43.7132 34.009 44.4306 32.2872 44.3828 31.6177C44.2871 30.709 45.4828 29.5611 46.0089 29.1307L40.2697 23.2959L39.0741 24.2524C39.0263 24.3003 38.9784 24.3003 38.8828 24.3003L34.148 23.8698C33.9567 23.8698 33.8132 23.9177 33.6697 24.0133L31.0871 26.5481C30.5611 28.9394 30.035 31.522 30.0828 32.0481C30.1784 32.0481 30.4176 32.0481 30.7524 31.9524C31.0393 31.8568 31.948 31.5698 32.3306 30.709C32.5219 30.3264 32.6654 29.9916 32.8089 29.6568C33.1915 28.7959 33.335 28.4611 33.6219 28.4133C33.7176 28.3655 33.8611 28.4133 33.9089 28.509C33.9567 28.5568 36.9697 30.7568 38.2611 29.2742C38.3567 29.1785 38.5002 29.1785 38.5958 29.2742C38.6915 29.3698 38.6915 29.5133 38.6437 29.609L37.6871 30.9003Z"
        fill="#121926"
      />
      <path
        d="M22.4305 36.4479L24.4392 34.4392C25.0132 33.8653 25.9218 33.8653 26.4958 34.4392C27.0697 35.0131 27.0697 35.9218 26.4958 36.4957L24.4871 38.5044C23.961 39.0305 23.1001 39.0305 22.574 38.5044L22.3827 38.3131C21.9045 37.8349 21.9045 36.974 22.4305 36.4479Z"
        fill="white"
      />
      <path
        d="M23.5303 39.1744C23.0999 39.1744 22.7173 39.0309 22.4303 38.6961L22.239 38.5048C21.952 38.2179 21.7607 37.7874 21.7607 37.4048C21.7607 36.9744 21.9042 36.5918 22.239 36.3048L24.2477 34.2961C24.9173 33.6266 25.9694 33.6266 26.639 34.2961C27.3086 34.9657 27.3086 36.0179 26.639 36.6874L24.6303 38.6961C24.3912 38.9831 23.9607 39.1744 23.5303 39.1744ZM25.4434 34.2961C25.1086 34.2961 24.8216 34.3918 24.5825 34.6309L22.5738 36.6396C22.3825 36.8309 22.239 37.1179 22.239 37.4048C22.239 37.6918 22.3347 37.9787 22.5738 38.17L22.7651 38.3613C23.1955 38.7918 23.9129 38.7918 24.3434 38.3613L26.352 36.3526C26.8303 35.8744 26.8303 35.1092 26.352 34.6309C26.1129 34.3918 25.7781 34.2961 25.4434 34.2961Z"
        fill="#121926"
      />
      <path
        d="M24.7739 38.4083L26.8783 36.3039C27.5478 35.6344 28.6478 35.6344 29.3174 36.3039C29.987 36.9735 29.987 38.0735 29.3174 38.7431L27.2131 40.8474C26.5913 41.4691 25.6348 41.4691 25.0131 40.8474L24.7739 40.6083C24.1522 40.0344 24.1522 39.03 24.7739 38.4083Z"
        fill="white"
      />
      <path
        d="M26.1132 41.5651C25.6349 41.5651 25.2045 41.3738 24.8219 41.0391L24.5827 40.7999C24.2479 40.4652 24.0566 39.9869 24.0566 39.5086C24.0566 39.0304 24.2479 38.5521 24.5827 38.2173L26.6871 36.113C27.0697 35.7304 27.5479 35.5391 28.074 35.5391C28.6001 35.5391 29.0784 35.7304 29.461 36.113C29.8436 36.4956 30.0349 36.9738 30.0349 37.4999C30.0349 38.026 29.8436 38.5043 29.461 38.8869L27.3566 40.9912C27.0219 41.4217 26.5914 41.5651 26.1132 41.5651ZM28.1219 36.0651C27.7392 36.0651 27.3566 36.2086 27.0697 36.4956L24.9653 38.5999C24.7262 38.8391 24.5827 39.1738 24.5827 39.5565C24.5827 39.9391 24.7262 40.226 24.9653 40.513L25.2045 40.7521C25.7306 41.2782 26.5436 41.2782 27.0697 40.7521L29.174 38.6478C29.461 38.3608 29.6045 37.9782 29.6045 37.5956C29.6045 37.213 29.461 36.8304 29.174 36.5434C28.8871 36.2565 28.5045 36.0651 28.1219 36.0651Z"
        fill="#121926"
      />
      <path
        d="M27.2131 40.9436L29.5088 38.6479C30.1305 38.0262 31.1349 38.0262 31.7566 38.6479C32.3784 39.2697 32.3784 40.274 31.7566 40.8958L29.461 43.1914C28.8871 43.7653 27.9784 43.7653 27.4523 43.1914L27.2131 42.9523C26.6392 42.4262 26.6392 41.5175 27.2131 40.9436Z"
        fill="white"
      />
      <path
        d="M28.4565 43.8611C28.0261 43.8611 27.5956 43.6698 27.2608 43.3828L27.0217 43.1437C26.6869 42.8089 26.5435 42.4263 26.5435 41.9481C26.5435 41.5176 26.7348 41.0872 27.0217 40.7524L29.3174 38.4568C29.6522 38.122 30.1304 37.9307 30.6087 37.9307C31.0869 37.9307 31.5652 38.122 31.9 38.4568C32.2348 38.7915 32.4261 39.2698 32.4261 39.7481C32.4261 40.2263 32.2348 40.7046 31.9 41.0394L29.6522 43.3828C29.3174 43.6698 28.8869 43.8611 28.4565 43.8611ZM30.6565 38.4089C30.2739 38.4089 29.9391 38.5524 29.7 38.7915L27.4043 41.0872C27.1652 41.3263 27.0695 41.6133 27.0695 41.9481C27.0695 42.2828 27.213 42.5698 27.4043 42.8089L27.6435 43.0481C28.0739 43.4785 28.8869 43.4785 29.3174 43.0481L31.613 40.7524C31.8522 40.5133 31.9956 40.1785 31.9956 39.7959C31.9956 39.4133 31.8522 39.0785 31.613 38.8394C31.3739 38.5524 31.0391 38.4089 30.6565 38.4089Z"
        fill="#121926"
      />
      <path
        d="M29.7001 43.2391L31.9479 40.8956C32.474 40.3217 33.3827 40.3217 33.9566 40.8478L34.1001 40.9912C34.674 41.5173 34.674 42.426 34.1479 42.9999L31.9001 45.3434C31.4218 45.8695 30.6088 45.8695 30.0827 45.3912L29.7479 45.0565C29.2218 44.5782 29.2218 43.7652 29.7001 43.2391Z"
        fill="white"
      />
      <path
        d="M30.9434 45.9655C30.5608 45.9655 30.1782 45.822 29.8912 45.535L29.5564 45.2002C28.9347 44.6263 28.9347 43.6698 29.5086 43.0481L29.6999 42.8568L31.7564 40.6568C32.3782 39.9872 33.4304 39.9872 34.0999 40.6089L34.2434 40.7524C34.5782 41.0394 34.7695 41.4698 34.7695 41.9002C34.7695 42.3307 34.626 42.7611 34.3391 43.0959L32.0434 45.4872C31.8043 45.7741 31.4217 45.9655 30.9434 45.9655C30.9912 45.9655 30.9912 45.9655 30.9434 45.9655ZM29.7956 43.5263C29.5086 43.9568 29.5564 44.5307 29.9391 44.9133L30.2738 45.2481C30.4651 45.4394 30.7521 45.535 30.9912 45.535C31.2782 45.535 31.5173 45.3915 31.7086 45.2002L33.9564 42.8568C34.1478 42.6176 34.2912 42.3307 34.2912 41.9959C34.2912 41.6611 34.1478 41.3741 33.9086 41.1828L33.7651 41.0394C33.2869 40.6089 32.5695 40.6089 32.0912 41.0872L29.7956 43.5263Z"
        fill="#121926"
      />
      <path
        d="M42.2307 38.6954C42.1828 38.6954 42.135 38.6954 42.0872 38.6476L39.5524 37.0693C39.4568 37.0215 39.4089 36.8302 39.4568 36.7345C39.5046 36.6389 39.6959 36.5911 39.7915 36.6389L42.3263 38.2171C42.422 38.265 42.4698 38.4563 42.422 38.5519C42.3741 38.6476 42.3263 38.6954 42.2307 38.6954Z"
        fill="#121926"
      />
      <path
        d="M40.5085 41.5177C40.4607 41.5177 40.4128 41.5177 40.365 41.4698L37.8302 39.8916C37.7346 39.8438 37.6868 39.6525 37.7346 39.5568C37.7824 39.4611 37.9737 39.4133 38.0694 39.4611L40.6041 41.0394C40.6998 41.0872 40.7476 41.2785 40.6998 41.3742C40.652 41.5177 40.6041 41.5177 40.5085 41.5177Z"
        fill="#121926"
      />
      <path
        d="M38.4523 43.9561C38.4045 43.9561 38.3567 43.9561 38.3089 43.9083L35.7741 42.3301C35.6784 42.2822 35.6306 42.0909 35.6784 41.9953C35.7263 41.8996 35.9176 41.8518 36.0132 41.8996L38.548 43.4779C38.6436 43.5257 38.6915 43.717 38.6436 43.8127C38.5958 43.9083 38.548 43.9561 38.4523 43.9561Z"
        fill="#121926"
      />
      <path
        d="M21.9519 19.9955L23.6737 21.2389C24.2954 21.6694 24.4867 22.5781 24.0085 23.1998L18.6998 30.7563C18.2693 31.3781 17.3606 31.5694 16.7389 31.0911L15.0171 29.8476C14.3954 29.4172 14.2041 28.5085 14.6824 27.8868L19.9911 20.3302C20.4215 19.7085 21.2824 19.565 21.9519 19.9955Z"
        fill="#D1E9FF"
      />
      <path
        d="M41.7041 20.33L43.1867 18.8474C43.7607 18.2735 44.6215 18.2735 45.1954 18.8474L51.0781 24.73C51.652 25.3039 51.652 26.1648 51.0781 26.7387L49.5954 28.2213C49.0215 28.7953 48.1607 28.7953 47.5867 28.2213L41.7041 22.3387C41.178 21.7648 41.178 20.8561 41.7041 20.33Z"
        fill="#D1E9FF"
      />
    </g>
    <defs>
      <filter
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
        height="66"
        id="filter0_dd_3353_197334"
        width="66"
        x="0"
        y="0"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0705882 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 0.06 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow_3353_197334"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0705882 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 0.1 0"
        />
        <feBlend
          in2="effect1_dropShadow_3353_197334"
          mode="normal"
          result="effect2_dropShadow_3353_197334"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_3353_197334"
          mode="normal"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const businessCheckIcon = (
  <svg
    fill="none"
    height="66"
    viewBox="0 0 67 66"
    width="67"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_3353_197329)">
      <path
        d="M3 32C3 15.4315 16.4315 2 33 2C49.5685 2 63 15.4315 63 32C63 48.5685 49.5685 62 33 62C16.4315 62 3 48.5685 3 32Z"
        fill="white"
      />
      <path
        d="M33 2.5C49.2924 2.5 62.5 15.7076 62.5 32C62.5 48.2924 49.2924 61.5 33 61.5C16.7076 61.5 3.5 48.2924 3.5 32C3.5 15.7076 16.7076 2.5 33 2.5Z"
        stroke="#8C96A2"
      />
      <path
        d="M18.6523 20.0436C18.6523 18.723 19.723 17.6523 21.0436 17.6523H44.9567C46.2774 17.6523 47.348 18.723 47.348 20.0436V43.9567C47.348 45.2774 46.2774 46.348 44.9567 46.348H21.0436C19.723 46.348 18.6523 45.2774 18.6523 43.9567V20.0436Z"
        fill="white"
      />
      <path
        d="M21.522 21.2387C21.522 20.7105 21.9502 20.2822 22.4785 20.2822H43.522C44.0502 20.2822 44.4785 20.7105 44.4785 21.2387V42.7605C44.4785 43.2888 44.0502 43.717 43.522 43.717H22.4785C21.9502 43.717 21.522 43.2888 21.522 42.7605V21.2387Z"
        fill="#D1E9FF"
      />
      <path
        clip-rule="evenodd"
        d="M18.6235 21.7195C18.7546 21.7037 18.8738 21.7971 18.8896 21.9282C19.0343 23.124 20.1111 25.6255 23.2708 25.9881C24.8436 26.1687 25.9589 25.6076 26.7238 24.836C27.4968 24.0563 27.9148 23.0568 28.0602 22.3809C28.0837 22.2719 28.1794 22.1936 28.2909 22.1921C28.4025 22.1907 28.5002 22.2666 28.5264 22.375C28.8196 23.5867 30.1506 25.9866 33.1148 25.9866C36.0791 25.9866 37.4101 23.5867 37.7033 22.375C37.7287 22.2701 37.8211 22.1952 37.929 22.1922C38.0368 22.1892 38.1334 22.2587 38.1646 22.362C38.3459 22.9614 38.7979 23.8744 39.5569 24.6337C40.3116 25.3889 41.3631 25.9866 42.7566 25.9866C44.1489 25.9866 45.1599 25.39 45.865 24.6391C46.5752 23.8828 46.9708 22.9729 47.1155 22.375C47.1465 22.2466 47.2758 22.1678 47.4041 22.1988C47.5325 22.2299 47.6114 22.3591 47.5803 22.4875C47.4189 23.1544 46.9881 24.1418 46.2137 24.9665C45.4343 25.7966 44.3027 26.4648 42.7566 26.4648C41.2116 26.4648 40.044 25.7977 39.2186 24.9718C38.6332 24.3861 38.2164 23.7177 37.9525 23.1411C37.3835 24.5281 35.9139 26.4648 33.1148 26.4648C30.3642 26.4648 28.8974 24.5945 28.3076 23.2135C28.0661 23.8476 27.6632 24.5677 27.0635 25.1727C26.2061 26.0375 24.9493 26.6622 23.2163 26.4633C19.7645 26.0671 18.5762 23.3196 18.4148 21.9857C18.399 21.8545 18.4924 21.7354 18.6235 21.7195Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M20.5653 17.8913C19.6408 17.8913 18.8913 18.6408 18.8913 19.5653V44.4348C18.8913 45.3593 19.6408 46.1087 20.5653 46.1087H45.4348C46.3593 46.1087 47.1087 45.3593 47.1087 44.4348V19.5653C47.1087 18.6408 46.3593 17.8913 45.4348 17.8913H24.8904C24.7583 17.8913 24.6513 17.7843 24.6513 17.6522C24.6513 17.5201 24.7583 17.4131 24.8904 17.4131H45.4348C46.6234 17.4131 47.587 18.3766 47.587 19.5653V44.4348C47.587 45.6234 46.6234 46.587 45.4348 46.587H20.5653C19.3766 46.587 18.4131 45.6234 18.4131 44.4348V19.5653C18.4131 18.3766 19.3766 17.4131 20.5653 17.4131H21.5634C21.6954 17.4131 21.8025 17.5201 21.8025 17.6522C21.8025 17.7843 21.6954 17.8913 21.5634 17.8913H20.5653Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M21.2827 32.4786C21.2827 31.5541 22.0322 30.8047 22.9566 30.8047H26.7827C27.7072 30.8047 28.4566 31.5541 28.4566 32.4786V46.5873H21.2827V32.4786ZM22.9566 31.2829C22.2963 31.2829 21.761 31.8183 21.761 32.4786V46.109H27.9784V32.4786C27.9784 31.8183 27.4431 31.2829 26.7827 31.2829H22.9566Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        d="M23.9131 38.696C23.9131 38.9602 23.6989 39.1743 23.4348 39.1743C23.1707 39.1743 22.9565 38.9602 22.9565 38.696C22.9565 38.4319 23.1707 38.2178 23.4348 38.2178C23.6989 38.2178 23.9131 38.4319 23.9131 38.696Z"
        fill="#121926"
      />
      <path
        clip-rule="evenodd"
        d="M18.6235 21.7195C18.7546 21.7037 18.8738 21.7971 18.8896 21.9282C19.0343 23.124 20.1111 25.6255 23.2708 25.9881C24.8436 26.1687 25.9589 25.6076 26.7238 24.836C27.4968 24.0563 27.9148 23.0568 28.0602 22.3809C28.0837 22.2719 28.1794 22.1936 28.2909 22.1921C28.4025 22.1907 28.5002 22.2666 28.5264 22.375C28.8196 23.5867 30.1506 25.9866 33.1148 25.9866C36.0791 25.9866 37.4101 23.5867 37.7033 22.375C37.7287 22.2701 37.8211 22.1952 37.929 22.1922C38.0368 22.1892 38.1334 22.2587 38.1646 22.362C38.3459 22.9614 38.7979 23.8744 39.5569 24.6337C40.3116 25.3889 41.3631 25.9866 42.7566 25.9866C44.1489 25.9866 45.1599 25.39 45.865 24.6391C46.5752 23.8828 46.9708 22.9729 47.1155 22.375C47.1465 22.2466 47.2758 22.1678 47.4041 22.1988C47.5325 22.2299 47.6114 22.3591 47.5803 22.4875C47.4189 23.1544 46.9881 24.1418 46.2137 24.9665C45.4343 25.7966 44.3027 26.4648 42.7566 26.4648C41.2116 26.4648 40.044 25.7977 39.2186 24.9718C38.6332 24.3861 38.2164 23.7177 37.9525 23.1411C37.3835 24.5281 35.9139 26.4648 33.1148 26.4648C30.3642 26.4648 28.8974 24.5945 28.3076 23.2135C28.0661 23.8476 27.6632 24.5677 27.0635 25.1727C26.2061 26.0375 24.9493 26.6622 23.2163 26.4633C19.7645 26.0671 18.5762 23.3196 18.4148 21.9857C18.399 21.8545 18.4924 21.7354 18.6235 21.7195Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M20.5653 17.8913C19.6408 17.8913 18.8913 18.6408 18.8913 19.5653V44.4348C18.8913 45.3593 19.6408 46.1087 20.5653 46.1087H45.4348C46.3593 46.1087 47.1087 45.3593 47.1087 44.4348V19.5653C47.1087 18.6408 46.3593 17.8913 45.4348 17.8913H24.8904C24.7583 17.8913 24.6513 17.7843 24.6513 17.6522C24.6513 17.5201 24.7583 17.4131 24.8904 17.4131H45.4348C46.6234 17.4131 47.587 18.3766 47.587 19.5653V44.4348C47.587 45.6234 46.6234 46.587 45.4348 46.587H20.5653C19.3766 46.587 18.4131 45.6234 18.4131 44.4348V19.5653C18.4131 18.3766 19.3766 17.4131 20.5653 17.4131H21.5634C21.6954 17.4131 21.8025 17.5201 21.8025 17.6522C21.8025 17.7843 21.6954 17.8913 21.5634 17.8913H20.5653Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        d="M30.1304 32.0005C30.1304 31.4722 30.5586 31.0439 31.0869 31.0439H43.0434C43.5717 31.0439 43.9999 31.4722 43.9999 32.0005V41.0874C43.9999 41.6157 43.5717 42.0439 43.0434 42.0439H31.0869C30.5586 42.0439 30.1304 41.6157 30.1304 41.0874V32.0005Z"
        fill="#D1E9FF"
      />
      <path
        clip-rule="evenodd"
        d="M43.0434 31.5222H31.0869C30.8228 31.5222 30.6086 31.7363 30.6086 32.0005V41.0874C30.6086 41.3516 30.8228 41.5657 31.0869 41.5657H43.0434C43.3076 41.5657 43.5217 41.3516 43.5217 41.0874V32.0005C43.5217 31.7363 43.3076 31.5222 43.0434 31.5222ZM31.0869 31.0439C30.5586 31.0439 30.1304 31.4722 30.1304 32.0005V41.0874C30.1304 41.6157 30.5586 42.0439 31.0869 42.0439H43.0434C43.5717 42.0439 43.9999 41.6157 43.9999 41.0874V32.0005C43.9999 31.4722 43.5717 31.0439 43.0434 31.0439H31.0869Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        d="M31.5654 33.435C31.5654 32.9068 31.9937 32.4785 32.522 32.4785H41.6089C42.1372 32.4785 42.5654 32.9068 42.5654 33.435V39.6524C42.5654 40.1807 42.1372 40.6089 41.6089 40.6089H32.522C31.9937 40.6089 31.5654 40.1807 31.5654 39.6524V33.435Z"
        fill="white"
      />
      <path
        clip-rule="evenodd"
        d="M42.248 31.3444C42.3458 31.4333 42.353 31.5845 42.2641 31.6822L37.4815 36.9431C37.3927 37.0408 37.2414 37.048 37.1437 36.9592C37.046 36.8703 37.0388 36.7191 37.1276 36.6214L41.9102 31.3605C41.9991 31.2628 42.1503 31.2556 42.248 31.3444Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M36.0387 31.3523C36.1321 31.4457 36.1321 31.5971 36.0387 31.6904L30.7779 36.9513C30.6845 37.0447 30.5331 37.0447 30.4397 36.9513C30.3463 36.8579 30.3463 36.7065 30.4397 36.6131L35.7005 31.3523C35.7939 31.2589 35.9453 31.2589 36.0387 31.3523Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        d="M23.9131 38.696C23.9131 38.9602 23.6989 39.1743 23.4348 39.1743C23.1707 39.1743 22.9565 38.9602 22.9565 38.696C22.9565 38.4319 23.1707 38.2178 23.4348 38.2178C23.6989 38.2178 23.9131 38.4319 23.9131 38.696Z"
        fill="#121926"
      />
      <rect fill="#175CD3" height="15" rx="7.5" width="15" x="48.5" y="3.5" />
      <rect height="15" rx="7.5" stroke="#175CD3" width="15" x="48.5" y="3.5" />
      <path
        clip-rule="evenodd"
        d="M60.3536 7.64645C60.5488 7.84171 60.5488 8.15829 60.3536 8.35355L54.8536 13.8536C54.6583 14.0488 54.3417 14.0488 54.1464 13.8536L51.6464 11.3536C51.4512 11.1583 51.4512 10.8417 51.6464 10.6464C51.8417 10.4512 52.1583 10.4512 52.3536 10.6464L54.5 12.7929L59.6464 7.64645C59.8417 7.45118 60.1583 7.45118 60.3536 7.64645Z"
        fill="white"
        fill-rule="evenodd"
      />
    </g>
    <defs>
      <filter
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
        height="66"
        id="filter0_dd_3353_197329"
        width="67"
        x="0"
        y="0"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0705882 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 0.06 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow_3353_197329"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0705882 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 0.1 0"
        />
        <feBlend
          in2="effect1_dropShadow_3353_197329"
          mode="normal"
          result="effect2_dropShadow_3353_197329"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_3353_197329"
          mode="normal"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const businessIcon = (
  <svg
    fill="none"
    height="66"
    viewBox="0 0 66 66"
    width="66"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_3353_205850)">
      <path
        d="M3 32C3 15.4315 16.4315 2 33 2C49.5685 2 63 15.4315 63 32C63 48.5685 49.5685 62 33 62C16.4315 62 3 48.5685 3 32Z"
        fill="white"
      />
      <path
        d="M33 2.5C49.2924 2.5 62.5 15.7076 62.5 32C62.5 48.2924 49.2924 61.5 33 61.5C16.7076 61.5 3.5 48.2924 3.5 32C3.5 15.7076 16.7076 2.5 33 2.5Z"
        stroke="#8C96A2"
      />
      <path
        d="M18.6523 20.0436C18.6523 18.723 19.723 17.6523 21.0436 17.6523H44.9567C46.2774 17.6523 47.348 18.723 47.348 20.0436V43.9567C47.348 45.2774 46.2774 46.348 44.9567 46.348H21.0436C19.723 46.348 18.6523 45.2774 18.6523 43.9567V20.0436Z"
        fill="white"
      />
      <path
        d="M21.522 21.2387C21.522 20.7105 21.9502 20.2822 22.4785 20.2822H43.522C44.0502 20.2822 44.4785 20.7105 44.4785 21.2387V42.7605C44.4785 43.2888 44.0502 43.717 43.522 43.717H22.4785C21.9502 43.717 21.522 43.2888 21.522 42.7605V21.2387Z"
        fill="#D1E9FF"
      />
      <path
        clip-rule="evenodd"
        d="M18.6235 21.7195C18.7546 21.7037 18.8738 21.7971 18.8896 21.9282C19.0343 23.124 20.1111 25.6255 23.2708 25.9881C24.8436 26.1687 25.9589 25.6076 26.7238 24.836C27.4968 24.0563 27.9148 23.0568 28.0602 22.3809C28.0837 22.2719 28.1794 22.1936 28.2909 22.1921C28.4025 22.1907 28.5002 22.2666 28.5264 22.375C28.8196 23.5867 30.1506 25.9866 33.1148 25.9866C36.0791 25.9866 37.4101 23.5867 37.7033 22.375C37.7287 22.2701 37.8211 22.1952 37.929 22.1922C38.0368 22.1892 38.1334 22.2587 38.1646 22.362C38.3459 22.9614 38.7979 23.8744 39.5569 24.6337C40.3116 25.3889 41.3631 25.9866 42.7566 25.9866C44.1489 25.9866 45.1599 25.39 45.865 24.6391C46.5752 23.8828 46.9708 22.9729 47.1155 22.375C47.1465 22.2466 47.2758 22.1678 47.4041 22.1988C47.5325 22.2299 47.6114 22.3591 47.5803 22.4875C47.4189 23.1544 46.9881 24.1418 46.2137 24.9665C45.4343 25.7966 44.3027 26.4648 42.7566 26.4648C41.2116 26.4648 40.044 25.7977 39.2186 24.9718C38.6332 24.3861 38.2164 23.7177 37.9525 23.1411C37.3835 24.5281 35.9139 26.4648 33.1148 26.4648C30.3642 26.4648 28.8974 24.5945 28.3076 23.2135C28.0661 23.8476 27.6632 24.5677 27.0635 25.1727C26.2061 26.0375 24.9493 26.6622 23.2163 26.4633C19.7645 26.0671 18.5762 23.3196 18.4148 21.9857C18.399 21.8545 18.4924 21.7354 18.6235 21.7195Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M20.5653 17.8913C19.6408 17.8913 18.8913 18.6408 18.8913 19.5653V44.4348C18.8913 45.3593 19.6408 46.1087 20.5653 46.1087H45.4348C46.3593 46.1087 47.1087 45.3593 47.1087 44.4348V19.5653C47.1087 18.6408 46.3593 17.8913 45.4348 17.8913H24.8904C24.7583 17.8913 24.6513 17.7843 24.6513 17.6522C24.6513 17.5201 24.7583 17.4131 24.8904 17.4131H45.4348C46.6234 17.4131 47.587 18.3766 47.587 19.5653V44.4348C47.587 45.6234 46.6234 46.587 45.4348 46.587H20.5653C19.3766 46.587 18.4131 45.6234 18.4131 44.4348V19.5653C18.4131 18.3766 19.3766 17.4131 20.5653 17.4131H21.5634C21.6954 17.4131 21.8025 17.5201 21.8025 17.6522C21.8025 17.7843 21.6954 17.8913 21.5634 17.8913H20.5653Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M21.2827 32.4786C21.2827 31.5541 22.0322 30.8047 22.9566 30.8047H26.7827C27.7072 30.8047 28.4566 31.5541 28.4566 32.4786V46.5873H21.2827V32.4786ZM22.9566 31.2829C22.2963 31.2829 21.761 31.8183 21.761 32.4786V46.109H27.9784V32.4786C27.9784 31.8183 27.4431 31.2829 26.7827 31.2829H22.9566Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        d="M23.9131 38.696C23.9131 38.9602 23.6989 39.1743 23.4348 39.1743C23.1707 39.1743 22.9565 38.9602 22.9565 38.696C22.9565 38.4319 23.1707 38.2178 23.4348 38.2178C23.6989 38.2178 23.9131 38.4319 23.9131 38.696Z"
        fill="#121926"
      />
      <path
        clip-rule="evenodd"
        d="M18.6235 21.7195C18.7546 21.7037 18.8738 21.7971 18.8896 21.9282C19.0343 23.124 20.1111 25.6255 23.2708 25.9881C24.8436 26.1687 25.9589 25.6076 26.7238 24.836C27.4968 24.0563 27.9148 23.0568 28.0602 22.3809C28.0837 22.2719 28.1794 22.1936 28.2909 22.1921C28.4025 22.1907 28.5002 22.2666 28.5264 22.375C28.8196 23.5867 30.1506 25.9866 33.1148 25.9866C36.0791 25.9866 37.4101 23.5867 37.7033 22.375C37.7287 22.2701 37.8211 22.1952 37.929 22.1922C38.0368 22.1892 38.1334 22.2587 38.1646 22.362C38.3459 22.9614 38.7979 23.8744 39.5569 24.6337C40.3116 25.3889 41.3631 25.9866 42.7566 25.9866C44.1489 25.9866 45.1599 25.39 45.865 24.6391C46.5752 23.8828 46.9708 22.9729 47.1155 22.375C47.1465 22.2466 47.2758 22.1678 47.4041 22.1988C47.5325 22.2299 47.6114 22.3591 47.5803 22.4875C47.4189 23.1544 46.9881 24.1418 46.2137 24.9665C45.4343 25.7966 44.3027 26.4648 42.7566 26.4648C41.2116 26.4648 40.044 25.7977 39.2186 24.9718C38.6332 24.3861 38.2164 23.7177 37.9525 23.1411C37.3835 24.5281 35.9139 26.4648 33.1148 26.4648C30.3642 26.4648 28.8974 24.5945 28.3076 23.2135C28.0661 23.8476 27.6632 24.5677 27.0635 25.1727C26.2061 26.0375 24.9493 26.6622 23.2163 26.4633C19.7645 26.0671 18.5762 23.3196 18.4148 21.9857C18.399 21.8545 18.4924 21.7354 18.6235 21.7195Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M20.5653 17.8913C19.6408 17.8913 18.8913 18.6408 18.8913 19.5653V44.4348C18.8913 45.3593 19.6408 46.1087 20.5653 46.1087H45.4348C46.3593 46.1087 47.1087 45.3593 47.1087 44.4348V19.5653C47.1087 18.6408 46.3593 17.8913 45.4348 17.8913H24.8904C24.7583 17.8913 24.6513 17.7843 24.6513 17.6522C24.6513 17.5201 24.7583 17.4131 24.8904 17.4131H45.4348C46.6234 17.4131 47.587 18.3766 47.587 19.5653V44.4348C47.587 45.6234 46.6234 46.587 45.4348 46.587H20.5653C19.3766 46.587 18.4131 45.6234 18.4131 44.4348V19.5653C18.4131 18.3766 19.3766 17.4131 20.5653 17.4131H21.5634C21.6954 17.4131 21.8025 17.5201 21.8025 17.6522C21.8025 17.7843 21.6954 17.8913 21.5634 17.8913H20.5653Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        d="M30.1304 32.0005C30.1304 31.4722 30.5586 31.0439 31.0869 31.0439H43.0434C43.5717 31.0439 43.9999 31.4722 43.9999 32.0005V41.0874C43.9999 41.6157 43.5717 42.0439 43.0434 42.0439H31.0869C30.5586 42.0439 30.1304 41.6157 30.1304 41.0874V32.0005Z"
        fill="#D1E9FF"
      />
      <path
        clip-rule="evenodd"
        d="M43.0434 31.5222H31.0869C30.8228 31.5222 30.6086 31.7363 30.6086 32.0005V41.0874C30.6086 41.3516 30.8228 41.5657 31.0869 41.5657H43.0434C43.3076 41.5657 43.5217 41.3516 43.5217 41.0874V32.0005C43.5217 31.7363 43.3076 31.5222 43.0434 31.5222ZM31.0869 31.0439C30.5586 31.0439 30.1304 31.4722 30.1304 32.0005V41.0874C30.1304 41.6157 30.5586 42.0439 31.0869 42.0439H43.0434C43.5717 42.0439 43.9999 41.6157 43.9999 41.0874V32.0005C43.9999 31.4722 43.5717 31.0439 43.0434 31.0439H31.0869Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        d="M31.5654 33.435C31.5654 32.9068 31.9937 32.4785 32.522 32.4785H41.6089C42.1372 32.4785 42.5654 32.9068 42.5654 33.435V39.6524C42.5654 40.1807 42.1372 40.6089 41.6089 40.6089H32.522C31.9937 40.6089 31.5654 40.1807 31.5654 39.6524V33.435Z"
        fill="white"
      />
      <path
        clip-rule="evenodd"
        d="M42.248 31.3444C42.3458 31.4333 42.353 31.5845 42.2641 31.6822L37.4815 36.9431C37.3927 37.0408 37.2414 37.048 37.1437 36.9592C37.046 36.8703 37.0388 36.7191 37.1276 36.6214L41.9102 31.3605C41.9991 31.2628 42.1503 31.2556 42.248 31.3444Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M36.0387 31.3523C36.1321 31.4457 36.1321 31.5971 36.0387 31.6904L30.7779 36.9513C30.6845 37.0447 30.5331 37.0447 30.4397 36.9513C30.3463 36.8579 30.3463 36.7065 30.4397 36.6131L35.7005 31.3523C35.7939 31.2589 35.9453 31.2589 36.0387 31.3523Z"
        fill="#121926"
        fill-rule="evenodd"
      />
      <path
        d="M23.9131 38.696C23.9131 38.9602 23.6989 39.1743 23.4348 39.1743C23.1707 39.1743 22.9565 38.9602 22.9565 38.696C22.9565 38.4319 23.1707 38.2178 23.4348 38.2178C23.6989 38.2178 23.9131 38.4319 23.9131 38.696Z"
        fill="#121926"
      />
    </g>
    <defs>
      <filter
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
        height="66"
        id="filter0_dd_3353_205850"
        width="66"
        x="0"
        y="0"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0705882 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 0.06 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow_3353_205850"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0705882 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 0.1 0"
        />
        <feBlend
          in2="effect1_dropShadow_3353_205850"
          mode="normal"
          result="effect2_dropShadow_3353_205850"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_3353_205850"
          mode="normal"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
